import { PaymentRequest, StripePaymentControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useStripeCharge = () =>
  useMutationWithLoading(
    async (params: { paymentRequest: PaymentRequest; xTENANTID?: string }) =>
      new StripePaymentControllerApi(getConfigObject()).makeChargeStripe(
        params.paymentRequest,
        params?.xTENANTID
      )
  );

import { loadStripe } from "@stripe/stripe-js";

let stripePromise: any;

export const getStripePromise = () => {
  if (!stripePromise)
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUB_KEY ?? "");

  return stripePromise;
};
